// extracted by mini-css-extract-plugin
export default {"transitionSpeed":".5s"};